import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../utils/date-format';

@Pipe({
  name: 'localDateTime'
})
export class ISO8601DatePipe implements PipeTransform {
  constructor(private dateFormat: DateFormat) { }
  transform(value: any): any {
    if (!value || value === '') {
      return '';
    }
    try {
      return this.dateFormat.format(value, 'yyyy-MM-dd');
    } catch (ex) {
      return '';
    }
  }
}
